import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';

export class ChayuthaDTO {
@ApiProperty()
@ApiPropertyOptional()
Id: number;
@ApiProperty()
name:string;
@ApiProperty()
fatheOrHusbandName: string;
@ApiProperty()
dod:Date;
@ApiProperty()
causeOfDeath:string;
@ApiProperty()
nomineeName: string;
@ApiProperty()
@ApiPropertyOptional()
familyMember1: string;
@ApiProperty()
@ApiPropertyOptional()
familyMember2: string;
@ApiProperty()
@ApiPropertyOptional()
familyMember3: string;
@ApiProperty()
@ApiPropertyOptional()
familyMember4: string;
@ApiProperty()
streetName: string;
@ApiProperty()
village:string;
@ApiProperty()
mandal: string;
@ApiProperty()
@MaxLength(10, { message: "Mobile number allows 10 characters only. " })
@Matches(new RegExp("^[0-9\\s]+$"),{ message:"Mobile no should be only numeric. " })
mobileNo:string;
@ApiProperty()
@Matches(new RegExp("^[0-9\\s]+$"),{ message:"aadhar should be only numeric. " })
aadharNo:string;
@ApiProperty()
villageHeadName:string;
@ApiProperty()
mandalHeadName: string;
@ApiProperty()
@ApiPropertyOptional()
currentStatus:string;
@ApiProperty()
@ApiPropertyOptional()
status: boolean;
createdAt : Date;
@ApiProperty()
@ApiPropertyOptional()
@IsOptional()
createdUser : number;
updatedAt : Date;
@ApiProperty()
@ApiPropertyOptional()
@IsOptional()
updatedUser : number;
@ApiProperty()
@ApiPropertyOptional()
versionFlag : number;
}


export class DeleteDTO {
  @ApiProperty()
  Id: number;
  @ApiProperty()
  status: boolean;
  updatedAt : Date;
  @ApiProperty()
  updatedUser : number;
}


export class StatusDto {
  @ApiProperty()
  Id: number;
  @ApiProperty()
  currentStatus: string;
  updatedAt : Date;
  @ApiProperty()
  updatedUser : number;
}
 




